export default __webpack_public_path__ + "static/media/a023-startup1.5a0cba26.png";